import type {
  AssortmentStatus,
  AssortmentType,
  ChortkeFilter,
  GuideItem,
  StatusHelpContent
} from './types';

export const ASSORTMENT_TITLES: Record<AssortmentType, string> = {
  'assortment region': 'کالاهای نیاز به اصلاح موجودی',
  'assortment vendor': 'کالاهای پرفروش شما'
};

export const ASSORTMENT_FILTERS: Record<AssortmentType, ChortkeFilter[]> = {
  'assortment region': [
    {title: 'ناموجود', selected: false, status: 'OutOfStock'},
    {title: 'موجود', selected: false, status: 'Available'}
  ],
  'assortment vendor': [
    {title: 'تمام شده', selected: false, status: 'OutOfStock'},
    {title: 'موجودی رو به اتمام', selected: false, status: 'Critical'},
    {title: 'موجودی عالی', selected: false, status: 'Available'}
  ]
};

export const ASSORTMENT_STATUS_LABELS: Partial<Record<AssortmentStatus, string>> = {
  Available: 'عالی',
  OutOfStock: 'تمام شده',
  Ugly: 'تمام شده',
  Unknown: 'نیاز به تعریف',
  Critical: 'رو به اتمام'
};

export const ASSORTMENT_STATUS_HELP: Partial<Record<AssortmentStatus, StatusHelpContent>> = {
  Available: {
    title: 'وضعیت موجودی مناسب',
    message: 'در حال حاضر این محصولات پرفروش رو به تعداد مناسبی در فروشگاه موجود دارید.'
  },
  OutOfStock: {
    title: 'وضعیت ناموجود',
    message:
      'متاسفانه موجودی این کالاها در فروشگاه شما تمام شده و فروشی بابت این کالاها ندارید. هر چه زودتر برای تامین آنها اقدام کنید.'
  },
  Ugly: {
    title: 'وضعیت ناموجود',
    message:
      'متاسفانه موجودی این کالاها در فروشگاه شما تمام شده و فروشی بابت این کالاها ندارید. هر چه زودتر برای تامین آنها اقدام کنید.'
  },
  Unknown: {
    title: 'نیاز به تعریف کالا در فروشگاه',
    message:
      'این کالا در حال حاضر در فروشگاه شما تعریف نشده است و برای فروش اینترنتی آن نیاز است تا این کالا در سیستم اسنپ اکسپرس وارد شود. برای این کار لطفاً با پشتیبانی تماس بگیرید.',
    notice: 'امکان دارد این کالا را با بارکد دیگری در فروشگاه خود داشته باشید.'
  },
  Critical: {
    title: 'وضعیت موجودی نامناسب',
    message:
      'تعداد موجودی این کالاها در فروشگاهت نزدیک به اتمام هست! زودتر برای تامین اونها برنامه‌ریزی کن.'
  }
};

export const ASSORTMENT_GUIDES: Record<AssortmentType, GuideItem[]> = {
  'assortment region': [
    {
      id: 1,
      image: 'guide/chortke/BSR/image1-1.png',
      text: 'چرتکه بهت کمک می‌کنه فروشت بیشتر بشه! در بخش کالاهای پرفروش منطقه می‌تونی کالاهایی که در اطراف فروشگاهت فروش زیادی نسبت به بقیه کالاها دارن ببینی.'
    },
    {
      id: 2,
      image: 'guide/chortke/BSR/image1-2.png',
      text: 'در این بخش می‌تونی کالاهای پرفروش منطقه رو براساس موجود و ناموجود بودن در فروشگاهت فیلتر کنی. برای فروش بیشتر می‌تونی سریع کالاهای پرفروش ناموجود در فروشگاهت رو تامین کنی.'
    },
    {
      id: 3,
      image: 'guide/chortke/BSR/image1-3.png',
      textImage: 'guide/chortke/BSR/region-text-3.svg'
    }
  ],
  'assortment vendor': [
    {
      id: 1,
      image: 'guide/chortke/BSS/image1-1.png',
      text: 'در این قسمت می‌تونی کالاهای پرفروش فروشگاهت رو براساس تعداد موجودی هر کالا ببینی و اگر موجودی نداشتی سریع تامین کنی که فروش فروشگاهت کاهش پیدا نکنه.'
    },
    {
      id: 2,
      image: 'guide/chortke/BSS/image1-2.png',
      text: 'در این قسمت می‌تونی کالاهای پرفروش فروشگاهت رو براساس تعدادشون فیلتر کنی.',
      details: [
        {
          title: 'ناموجود',
          description:
            'کالاهای پرفروش منطقه رو که داخل فروشگاهت در حال حاضر نداری رو بهت نمایش می‌ده.'
        },
        {
          title: 'موجودی نامناسب',
          description:
            'حواست باشه! براساس میزان فروشت این کالاهای پرفروش همین روزا نیاز به تامین دارن.'
        },
        {
          title: 'موجودی مناسب',
          description:
            'خیالت راحت! این کالاهای پرفروش در فروشگاهت موجودی دارن و فعلاً نیازی به تامینشون نداری.'
        }
      ]
    },
    {
      id: 3,
      image: 'guide/chortke/BSS/image1-3.png',
      textImage: 'guide/chortke/BSS/vendor-text-3.svg'
    }
  ]
};
